const FAQS = [
  {
    q: '樱花动漫网的动漫资源都是免费的吗？',
    a: '是的，樱花动漫网所有动漫资源均免费提供在线观看。我们致力于打造一个无门槛的动漫平台，无论是最新番剧还是经典完结动漫，都不需要付费即可观看。部分高清资源可能需要简单注册即可畅享。',
  },
  {
    q: '动漫更新频率如何？新番什么时候能看？',
    a: '樱花动漫网保持每日更新节奏。日本新番通常在播出后 2-4 小时内完成字幕制作并上架；国产动漫在平台首播后我们会第一时间同步更新。热门完结动漫也已全部收录，无需等待即可完整观看。',
  },
  {
    q: '支持哪些设备观看？可以离线下载吗？',
    a: '樱花动漫网全面支持 PC 浏览器、iOS 和 Android 手机平板。我们的移动客户端提供离线缓存功能，可以在 Wi-Fi 环境下提前下载动漫，之后无需网络也能流畅观看，非常适合通勤和旅行场景。',
  },
  {
    q: '画质怎么样？有高清选项吗？',
    a: '樱花动漫网提供多档画质选择，从 480P 到 1080P 高清均可自由切换。采用先进的视频压缩技术，在保证画质清晰的前提下最大限度减少流量消耗。推荐在 Wi-Fi 环境下选择最高画质，享受最佳的在线观看体验。',
  },
  {
    q: '如何找到我想看的动漫？支持搜索吗？',
    a: '当然支持！你可以通过顶部的动漫索引按类型浏览，也可以在搜索框中输入动漫名称直接查找。我们还提供了热门排行和精选推荐模块，帮你快速发现当下最受欢迎的动漫作品，追番不再迷茫。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500">关于樱花动漫网的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq) => (
            <details
              key={faq.q}
              className="group bg-background-50 border border-background-200/70 rounded-xl"
              open
            >
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <h3 className="text-sm font-medium text-foreground-900 pr-8">{faq.q}</h3>
                <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="flex-shrink-0 w-5 h-5 items-center justify-center text-foreground-400 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}